import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type InlineLoadingIndicatorProps = {
  size?: "sm" | "md" | "lg" | "xl";
  label?: string;
  className?: string;
  "aria-label"?: string;
};

const SIZE_CLASS = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-5 w-5",
  xl: "h-8 w-8",
} as const;

export function InlineLoadingIndicator({
  size = "md",
  label,
  className,
  "aria-label": ariaLabel = "Loading",
}: InlineLoadingIndicatorProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-2", className)}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <Skeleton className={cn("rounded-full", SIZE_CLASS[size])} aria-hidden="true" />
      {label ? <span className="text-xs text-muted-foreground">{label}</span> : null}
    </span>
  );
}

